import React, { useState } from "react";
import "./Steps_Banner.css";
import { Dropdown } from "react-bootstrap";
import Orange_Btn from "../../common/common_btn/orange_btn/Orange_Btn";
import { useNavigate } from "react-router-dom";
import { IDS } from "../../../utils/IDS";
import { encodeId } from "../../../utils/common";

const Steps_Banner = ({ event }) => {
  const [selectedLang, setSelectedLang] = useState("English");

  const handleSelect = (eventKey) => {
    setSelectedLang(eventKey);
  };

  const navigate = useNavigate()

  return (
    <section className="Steps_Banner">
      <div className="container">
        <div className="content_holder">
          <div className="banner_div">
            <img
              src={IDS.IMG_URL + event?.Event?.background_image}
              className="steps_banner"
            />
          </div>

          <div className="register_now_div">
            <div className="left_side_div">
              <div className="lang_div">
                <Dropdown onSelect={handleSelect}>
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    {selectedLang}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item eventKey="English">English</Dropdown.Item>
                    <Dropdown.Item eventKey="Hindi">Hindi</Dropdown.Item>
                    <Dropdown.Item eventKey="Marathi">Marathi</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <p className="price_text">₹ {event?.Event?.price || "0"}</p>
            </div>
            <div className="register_btn_div">
              <Orange_Btn btnText={"Register Now"} onClick={() => { navigate(`/personal-info-form/${encodeId(event?.event_id)}`) }} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
  // return (
  //   <section className="Steps_Banner">
  //     <div className="container">
  //       <div className="content_holder">
  //         <div className="banner_div">
  //           <img
  //             src="/assets/images/simple_steps/banner2.png"
  //             className="steps_banner"
  //           />
  //         </div>

  //         <div className="register_now_div">
  //           <div className="left_side_div">
  //             <div className="lang_div">
  //               <Dropdown onSelect={handleSelect}>
  //                 <Dropdown.Toggle variant="success" id="dropdown-basic">
  //                   {selectedLang}
  //                 </Dropdown.Toggle>

  //                 <Dropdown.Menu>
  //                   <Dropdown.Item eventKey="English">English</Dropdown.Item>
  //                   <Dropdown.Item eventKey="Hindi">Hindi</Dropdown.Item>
  //                   <Dropdown.Item eventKey="Marathi">Marathi</Dropdown.Item>
  //                 </Dropdown.Menu>
  //               </Dropdown>
  //             </div>
  //             <p className="price_text">INR 5699</p>
  //           </div>
  //           <div className="register_btn_div">
  //             <Orange_Btn btnText={"Register Now"} onClick={() => { navigate("/personal-info-form") }} />
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </section>
  // );
};

export default Steps_Banner;
